import SquareCardEditor   from './SquareCardEditor'
import StripeCardEditor   from './StripeCardEditor'

export default function PaymentCardEditor() {
  return document.getElementById('square-js') ? <SquareCardEditor /> : <StripeCardEditor />
}
